import React, { Component } from "react";
import PropTypes from "prop-types";
import { Form, Dropdown } from "semantic-ui-react";
import { collegeProgramApi } from "@api/colleges/colleges";

class ProgramSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      loading: false,
      error: null,
    };
  }

  async componentDidMount() {
    await this.fetchPrograms();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value !== this.props.value &&
      this.props.value &&
      this.state.options.length > 0
    ) {
      this.handleValueChange(this.props.value);
    }
  }

  handleValueChange = (value) => {
    if (!value) return;

    const { options } = this.state;
    let selectedOption = options.find((opt) => opt.value === value);

    if (!selectedOption) {
      selectedOption = options.find(
        (opt) =>
          opt.value.toLowerCase().includes(value.toLowerCase()) ||
          value.toLowerCase().includes(opt.value.toLowerCase())
      );
    }

    if (selectedOption && selectedOption.code) {
      this.props.onChange(
        { target: {} },
        {
          name: this.props.name,
          value: value,
          programCode: selectedOption.code,
        }
      );
    }
  };

  fetchPrograms = async () => {
    this.setState({ loading: true, error: null });
    try {
      const response = await collegeProgramApi.listPrograms();
      const programs = response.data.data || [];
      const options = programs.map((program) => ({
        key: program.id,
        value: program.name,
        text: program.name,
        code: program.code,
        college_id: program.collegeId,
      }));

      this.setState({ options, loading: false });

      if (this.props.value) {
        setTimeout(() => this.handleValueChange(this.props.value), 100);
      }
    } catch (error) {
      this.setState({
        error: "Failed to load programs",
        loading: false,
        options: [
          {
            key: "bscs",
            value: "BS Computer Science",
            text: "BS Computer Science",
            code: "BSCS",
          },
          {
            key: "bsit",
            value: "Bachelor of Science in Information Technology",
            text: "Bachelor of Science in Information Technology",
            code: "BSIT",
          },
          {
            key: "bsed",
            value: "Bachelor of Secondary Education",
            text: "Bachelor of Secondary Education",
            code: "BSED",
          },
          {
            key: "beed",
            value: "Bachelor of Elementary Education",
            text: "Bachelor of Elementary Education",
            code: "BEED",
          },
          {
            key: "bsba",
            value: "Bachelor of Science in Business Administration",
            text: "Bachelor of Science in Business Administration",
            code: "BSBA",
          },
          {
            key: "bsa",
            value: "Bachelor of Science in Accountancy",
            text: "Bachelor of Science in Accountancy",
            code: "BSA",
          },
          {
            key: "bsce",
            value: "Bachelor of Science in Civil Engineering",
            text: "Bachelor of Science in Civil Engineering",
            code: "BSCE",
          },
          {
            key: "bsabe",
            value:
              "Bachelor of Science in Agriculture and Biosystems Engineering",
            text: "Bachelor of Science in Agriculture and Biosystems Engineering",
            code: "BSABE",
          },
        ],
      });
    }
  };

  getEnhancedOptions = () => {
    const { value } = this.props;
    const { options } = this.state;

    if (!value) return options;

    const existingOption = options.find((opt) => opt.value === value);

    if (!existingOption && value) {
      return [
        ...options,
        {
          key: `current-${value}`,
          value: value,
          text: value,
          code: "",
        },
      ];
    }

    return options;
  };

  handleChange = (e, { name, value }) => {
    const { options } = this.state;
    const selectedOption = options.find((opt) => opt.value === value);
    this.props.onChange(e, {
      name,
      value,
      programCode: selectedOption?.code || "",
    });
  };

  render() {
    const { value, required, placeholder, label, name, disabled } = this.props;
    const { loading, error } = this.state;
    const dropdownOptions = this.getEnhancedOptions();

    const currentOption = this.state.options.find(
      (opt) =>
        opt.value === value ||
        opt.value.toLowerCase().includes(value?.toLowerCase() || "") ||
        (value?.toLowerCase() || "").includes(opt.value.toLowerCase())
    );

    return (
      <Form.Field required={required}>
        {label && <label>{label}</label>}
        <Dropdown
          placeholder={placeholder}
          fluid
          selection
          search
          name={name}
          value={value}
          options={dropdownOptions}
          onChange={this.handleChange}
          disabled={disabled || loading}
          loading={loading}
          error={!!error}
          className="program-selector"
          allowAdditions
          additionLabel="Add program: "
        />
        {error && (
          <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
            {error}
          </div>
        )}
        {/* Show current program code if available */}
        {value && (
          <div
            style={{
              fontSize: "11px",
              color: "#666",
              marginTop: "4px",
              fontStyle: "italic",
            }}
          >
            {currentOption?.code
              ? `Program Code: ${currentOption.code}`
              : "Program code will be assigned when you select from dropdown"}
          </div>
        )}
      </Form.Field>
    );
  }
}

ProgramSelector.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

ProgramSelector.defaultProps = {
  value: "",
  required: false,
  placeholder: "Select Program",
  label: "Program",
  disabled: false,
};

export default ProgramSelector;
